import styled from 'styled-components';

export const Panel = styled.div`
  display: grid;
  grid-gap: 32px;
  text-align: center;
  --panel-y: 0px;
  --panel-s: 1;
  --panel-o: 1;
  transform: translateY(var(--panel-y)) scale(var(--panel-s)) translateZ(0);
  opacity: var(--panel-o);
`;
